import Highcharts from "highcharts";
import Highstock from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";

// Must run before the first chart exists: highcharts-more composes axis handlers (WaterfallAxis)
// that read state created only by its own axis "init" handler, so any axis built before the module
// is applied throws on its next stacked redraw (STIC-15893). Registering it from a route chunk made
// that order depend on which page loaded first.
// The app bundles two independent Highcharts instances ("highcharts" and "highcharts/highstock"),
// hence the double registration.
HighchartsMore(Highcharts);
HighchartsMore(Highstock);
